.empty,
.error {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-8) var(--space-6);
  text-align: center;
}

.emptyIcon,
.errorIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  margin-bottom: var(--space-2);
  background: var(--surface-2);
  color: var(--text-2);
  border-radius: var(--radius-pill);
}

.errorIcon {
  background: var(--primary-soft);
  color: var(--danger-text);
}

.emptyTitle,
.errorTitle {
  font-family: var(--font-heading);
  font-size: var(--text-xl);
  font-weight: var(--weight-extrabold);
  color: var(--text);
}

.emptyText,
.errorText {
  max-width: 28rem;
  color: var(--text-2);
}

.emptyAction {
  margin-top: var(--space-4);
}

.spinnerWrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.spinner {
  width: var(--spinner-size);
  height: var(--spinner-size);
  border: 3px solid var(--surface-2);
  border-top-color: var(--primary);
  border-radius: var(--radius-pill);
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.skeleton {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.skeletonLine {
  display: block;
  height: 0.875rem;
  background: var(--surface-2);
  border-radius: var(--radius-sm);
  animation: pulse 1.4s ease-in-out infinite;
}

.skeletonLine:last-child {
  width: 60%;
}

@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}

.track {
  --progress-color: var(--success);

  width: 100%;
  height: 0.4375rem;
  overflow: hidden;
  background: var(--surface-2);
  border-radius: var(--radius-pill);
}

.track[data-tone='primary'] {
  --progress-color: var(--primary);
}

.track[data-tone='secondary'] {
  --progress-color: var(--secondary);
}

.fill {
  display: block;
  height: 100%;
  background: var(--progress-color);
  border-radius: var(--radius-pill);
}
